import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";
import { formatPrice } from "../../../../../utilities/formatPrice";

const WalletCard = ({
  balance,
  currencySymbol = "€",
  changeLabel = null,
  onWithdraw,
  onStatement,
  disabled = false,
}) => {
  return (
    <div
      className={`card border-round-lg flex flex-column justify-content-between p-4 h-full${disabled ? " opacity-80" : ""}`}
      style={{
        minHeight: "220px",
        border: "1px solid var(--theme-border, #EBEBEB)",
      }}
    >
      <div className="flex align-items-top justify-content-between mb-4">
        <div
          className="flex align-items-center gap-2 border-round-xl p-3"
          style={{ backgroundColor: "color-mix(in srgb, var(--theme-secondary) 15%, transparent)" }}
        >
          <i
            className="pi pi-wallet text-xl"
            style={{ color: "var(--theme-secondary, #335CFF)" }}
          />
        </div>
        <div>
          <span
            className="px-3 py-1 border-round-md text-xs font-medium"
            style={{
              backgroundColor: "var(--theme-border, #EBEBEB)",
              color: "var(--theme-text, #262626)",
            }}
          >
            {localeText("withdrawable")}
          </span>
        </div>
      </div>
      <div className="text-xs font-bold mb-2" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
        {localeText("walletEuro")}
      </div>
      <div className="mb-2">
        <span className="text-2xl font-bold" style={{ color: "var(--theme-text, #344563)" }}>
          {currencySymbol} {formatPrice(balance || 0)}
        </span>
        {changeLabel && (
          <span
            className="ml-2 text-xs border-round-xl py-1 px-2 font-medium"
            style={{
              backgroundColor: "color-mix(in srgb, var(--theme-secondary) 15%, transparent)",
              color: "var(--theme-secondary, #1FC16B)",
            }}
          >
            {changeLabel}
          </span>
        )}
      </div>
      <div className="text-xs" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
        {localeText("availableForWithdrawal")}
      </div>
      <hr className="my-4" style={{ borderColor: "var(--theme-border, #EBEBEB)" }} />
      <div className="flex gap-2 flex-wrap">
        <Button
          label={localeText("withdrawAction")}
          className="p-button-text text-sm flex-1 border-round-md"
          style={{
            backgroundColor: "color-mix(in srgb, var(--theme-secondary) 15%, transparent)",
            color: "var(--theme-secondary)",
          }}
          onClick={onWithdraw}
          disabled={disabled}
        />
        <Button
          label={localeText("statement")}
          className="p-button-text text-sm flex-1 border-round-md"
          style={{
            border: "1px solid var(--theme-border, #EBEBEB)",
            color: "var(--theme-text-muted, #5C5C5C)",
          }}
          onClick={onStatement}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default React.memo(WalletCard);
